/* eslint-disable no-unused-vars */
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { BsArrowsCollapse, BsArrowsExpand } from 'react-icons/bs'
import {
  HiOutlineChevronDown,
  HiOutlineChevronRight,
  HiOutlineInformationCircle,
  HiOutlinePencil,
  HiOutlineTrash,
} from 'react-icons/hi'
import { Link } from 'react-router-dom'
import { ButtonSubmit, color } from '../../../GlobalStyle'
import { Mask } from '../../../hooks/Mask'
import {
  Actions,
  Button,
  ContainerTable,
  FunctionsButton,
  Header,
  Item,
  Session,
  Sessions,
  Table,
  THead,
} from './style'
const ListTable = ({ products, handleClick, infosProductButton, handleEdit }) => {
  const [expansive, setExpansive] = useState([])

  const handleExpandable = (Rowid) => {
    const currentExpandedRows = expansive
    const isInExpensive = currentExpandedRows.includes(Rowid)
    const newExpandedRows = isInExpensive
      ? currentExpandedRows.filter((id) => id !== Rowid)
      : currentExpandedRows.concat(Rowid)

    setExpansive(newExpandedRows)
  }

  const isExpandable = (id) => {
    return expansive.includes(id)
  }
  let ids = products?.map((prod) => prod.id)

  return (
    <ContainerTable>
      <Header>
        <Actions>
          <Link to={'/create_products'}>
            <ButtonSubmit rounded width={'auto'} height={'auto'} padding={'12px'}>
              <AiOutlinePlus />
            </ButtonSubmit>
          </Link>
          <FunctionsButton>
            {/* <ButtonSubmit
              width={'190px'}
              background={color.cancel}
              invert
              margin={0}
              color={color.cancel}
            >
              <BsArrowsCollapse /> Excluir todos
            </ButtonSubmit> */}

            <ButtonSubmit
              width={'190px'}
              invert
              margin={0}
              onClick={() => (expansive.length > 0 ? setExpansive([]) : setExpansive(ids))}
            >
              {expansive.length > 0 ? (
                <>
                  <BsArrowsCollapse /> Contrair todos
                </>
              ) : (
                <>
                  <BsArrowsExpand /> Expandir todos
                </>
              )}
            </ButtonSubmit>
          </FunctionsButton>
        </Actions>
      </Header>
      <Table>
        <THead>
          <tr>
            <th style={{ width: '33.33%' }}>Plataforma</th>
            <th style={{ width: '33.33%' }}>Preço zero</th>
            <th style={{ width: '33.33%' }}>Preço de venda</th>
          </tr>
        </THead>

        <tbody>
          {products?.map((product) => {
            return (
              <>
                <Item role={'row'} key={product.id} onClick={() => handleExpandable(product.id)}>
                  <td colSpan={3}>
                    <Sessions>
                      <Session>
                        <button>
                          {isExpandable(product.id) ? (
                            <HiOutlineChevronDown />
                          ) : (
                            <HiOutlineChevronRight />
                          )}
                        </button>

                        <span>
                          {product.id_contexto} &nbsp;
                          {product.nome}
                        </span>
                      </Session>

                      <Session>
                        <Button color={color.brand} onClick={(e) => handleEdit(e, product)}>
                          <HiOutlinePencil style={{ position: 'absolute' }} />
                        </Button>

                        <Button color={'#D3384B'} onClick={(e) => handleClick(e, product.id)}>
                          <HiOutlineTrash style={{ position: 'absolute' }} />
                        </Button>
                        <Button color={' #D4BF0D'} onClick={(e) => infosProductButton(e, product)}>
                          <HiOutlineInformationCircle style={{ position: 'absolute' }} />
                        </Button>
                      </Session>
                    </Sessions>
                  </td>
                </Item>

                {isExpandable(product.id) &&
                  product?.plataformas?.map((plataform) => {
                    return (
                      <tr key={plataform.id}>
                        <td>{plataform.nome}</td>
                        <td>{Mask.money(plataform.preco_zero)}</td>
                        <td style={{ color: `${color.brand}`, fontWeight: 'bold' }}>
                          {Mask.money(plataform.preco_venda)}
                        </td>
                      </tr>
                    )
                  })}
              </>
            )
          })}
        </tbody>
      </Table>
    </ContainerTable>
  )
}
export default ListTable
